import React from 'react';
import { Check } from 'lucide-react';
export function ProductFeatures() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-gradient-to-br from-gray-900 to-blue-900 text-white px-4" data-id="element-75">
      <div className="max-w-6xl mx-auto" data-id="element-76">
        <div className="text-center mb-12" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-78">
            🧠 ¿Qué incluye el producto principal?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-79">
          <div className="order-2 md:order-1 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/mYTtBZPeqV6p6KDq5WHDKk/1_Cover.png" alt="Mapas Mentales de Anatomía Humana" className="w-full max-w-md mx-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-81" />
          </div>

          <div className="order-1 md:order-2 space-y-8" data-id="element-82">
            <div data-id="element-83">
              <h3 className="text-2xl md:text-3xl font-bold text-yellow-400 mb-6" data-id="element-84">
                📗 Mapas Mentales de Anatomía Humana
              </h3>
              <ul className="space-y-4" data-id="element-85">
                {['Mapas mentales claros y organizados', 'Sistemas del cuerpo explicados de forma visual', 'Ideal para Medicina, Enfermería y carreras de la salud', 'Perfecto para estudiar, repasar y preparar exámenes', 'Material digital con acceso inmediato'].map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-86">
                    <div className="bg-green-500 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-87">
                      <Check className="w-4 h-4 text-white" data-id="element-88" />
                    </div>
                    <span className="text-lg md:text-xl text-gray-100" data-id="element-89">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-white/10 p-6 rounded-xl border border-white/20" data-id="element-90">
              <p className="text-xl font-bold text-center text-white" data-id="element-91">
                👉 Estudia con claridad y confianza, no a ciegas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}